import { useRouter } from 'next/router';
import { useEffect } from 'react';
import ProcuraLoading from '@/components/common/ui-feedback/ProcuraLoading';
import { useAuth } from '@/hooks/AuthContext';

export default function IndexPage() {
  const { loginStatus, user } = useAuth();
  const router = useRouter();

  // This redirects to correct page based on user type
  useEffect(() => {
    if (loginStatus !== 'LOGGED_IN') {
      router.push('/login');
    } else if (loginStatus === 'LOGGED_IN') {
      switch (user.type) {
        case 'admin':
          router.push('/dashboard');
          break;
        case 'client':
          {
            if (user.role.canViewPricing && user.role.canCreateOrder)
              router.push('/dashboard');
            else router.push('/clients/me');
          }
          break;
      }
    }
  }, [loginStatus, user]);

  return <ProcuraLoading />;
}

IndexPage.getLayoutParams = () => ({
  useNewLayout: false,
  removePadding: true,
});
